import type { SupportNeed } from '@/types/career-growth';

import { SUPPORT_NEEDS } from '@/types/career-growth';

/**
 * The support needs a manager can pick, grouped and ordered the way the meeting asks them. Every
 * need of the API is not offered: the ones left out stay readable on the answers that hold them.
 */
export const SUPPORT_NEED_GROUPS = [
    { id: 'learning', needs: ['FormalTraining', 'SelfPacedResources', 'DevelopmentBudget'] },
    { id: 'coaching', needs: ['InternalMentoring', 'ProfessionalCoaching', 'MoreManagerMeetings'] },
    {
        id: 'experience',
        needs: [
            'StretchProject',
            'ProgressiveDelegation',
            'TemporaryAssignment',
            'TrainOrMentorOthers',
        ],
    },
    {
        id: 'exposure',
        needs: ['LeadershipVisibility', 'CrossFunctionalCommittee', 'IndustryEvents'],
    },
    { id: 'conditions', needs: ['ProtectedTime', 'CareerPathClarity'] },
    { id: 'other', needs: ['NoSupportNeeded'] },
] as const satisfies ReadonlyArray<{ id: string; needs: readonly SupportNeed[] }>;

const OFFERED_SUPPORT_NEEDS = new Set<SupportNeed>(
    SUPPORT_NEED_GROUPS.flatMap(({ needs }) => needs),
);

/** Needs the API still accepts and older answers may hold, no longer offered to a new choice. */
export const RETIRED_SUPPORT_NEEDS: readonly SupportNeed[] = SUPPORT_NEEDS.filter(
    (need) => !OFFERED_SUPPORT_NEEDS.has(need),
);

/**
 * The choice that reveals the free-text support field. A value of the list only, never a need
 * sent to the API: what travels is the text itself.
 */
export const OTHER_SUPPORT_VALUE = 'Other';
